<rt-infobox iconName="info-outline" [isDismissible]="false" margin-bottom>
  {{ 'app.pricing.custom_product.infobox_text' | translate }}
  <a (click)="finishOrder.emit()" class="link">
    {{ 'app.pricing.custom_product.infobox_link' | translate }}
  </a>
</rt-infobox>
